export const packageId = 3 as number;
export const packageInfo = 'com.sambad.plinkobet';
export const defaultChannel = 'plinkobet';
export const disabledPhoneCode = true;
export const apiSendPhoneCode = false;
export const defaultPhoneCode = '91';
export const homePage = 'Index';
export const defaultApkPath = 'plinkobet';
export const defaultApkName = 'plinkobet-ins.apk';
export const defaultApkPrefix = 'plinkobet-';
export const gameNavigateVersion = 1;
